import { Provider, ProviderId, ProvidersRecord } from '../provider/types';

/**
 * Хелпер нужен, так как невозможно определить корректный рекурсивный тип провайдера
 */
export const getInnerProviders = (provider: Provider) => {
  return provider.innderDeps as ProvidersRecord;
};

export const checkCircularDependency = (
  provider: Provider,
  seen: Set<ProviderId>
): void => {
  if (seen.has(provider.id)) {
    throw new Error(
      `Module: ${provider.containerName}\n Cyclic dependency: ${Array.from(seen.values()).concat([provider.id]).join(' -> ')}`
    );
  }

  for (const p of Object.values(getInnerProviders(provider))) {
    checkCircularDependency(p, new Set([...seen, provider.id]));
  }
};
